import React, { useEffect, useState } from "react";
import MobileFooter from "../footer/MobileFooter";

import SingleCompetition from "./SingleCompetition";
import Subcompetition from "./Subcompetition";
import "./competition.css";
import { useDispatch, useSelector } from "react-redux";
import { path } from "../../path";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import axios from "axios";
import LogoutModal from "../Modals/LogoutModal";
import { useContext } from "react";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { WebSocketContext } from "../../WebSocket";
import EditContest from "./EditContest";
import EnterPasswordModal from "../Modals/EnterPasswordModal";
import NotificationModal from "./NotificationModal";
import ContestOptionsModal from "../Modals/ContestOptionsModal";
import DataExtractionModel from "../Modals/DataExtractionModel";
import AnalyticsModel from "../Modals/AnalyticsModal";
import DeleteContestButton from "./DeleteContestButton";
import UrlShortenerModal from "../WebApp/UrlShortnerModal";
import TestimonialUpdateModal from "../Modals/TestimonialUpdateModal";
import ActivityReportModal from "../Modals/ActivityReportModal";

function formatDate(dateString) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const dateParts = dateString?.split("-");
  const year = dateParts[0].slice(2);
  const month = months[parseInt(dateParts[1]) - 1];
  const day = parseInt(dateParts[2]?.split(" ")[0]);
  const time = dateParts[2]?.split(" ")[2];
  const hour = parseInt(time?.split(":")[0]);
  const minute = parseInt(time?.split(":")[1]);
  const period = hour >= 12 ? "pm" : "am";
  const hour12 = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;

  return `${day} ${month} ${year}, ${hour12}:${minute < 10 ? "0" + minute : minute
    } ${period}`;
}

const Competition = () => {
  const history = useHistory();

  const { user, token } = useSelector((state) => state.AuthReducer);
  const [contestData, setContestData] = useState([]);
  const [selectedCompetition, setSelectedCompetition] = useState();
  const [isRightSectionOpen, setIsRightSectionOpen] = useState(true);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  // const [ongoingContests, setOngoingContests] = useState([]);
  const [upcommingContests, setUpcommingContests] = useState([]);
  const [currentDate, _] = useState(new Date());
  const [modal, setModal] = useState(false);
  // const [errMsg, setErrMsg] = useState(null);
  const [selectItem, setSelectItem] = useState(0);
  const [notificationModal, setNotificationModal] = useState(false)
  const [isOptionsModal, setIsOptionsModal] = useState(false);
  const [isDataExtractionModel, setIsDataExtractionModel] = useState(false);
  const [isAnalyticsModel, setIsAnalyticsModel] = useState(false);
  const [isReportsModel, setIsReportsModel] = useState(false);
  const [isUrlShortnerModel, setIsUrlShortnerModel] = useState(false);
  const [isTestimonialUpdateModal, setIsTestimonialUpdateModal] = useState(false);

  // Marketing-admin result-declaration notifications
  const [marketingNotifications, setMarketingNotifications] = useState([]);
  const [showMarketingBell, setShowMarketingBell] = useState(false);

  const marketingUnreadCount = marketingNotifications.filter((n) => !n.seen).length;

  const fetchMarketingNotifications = async () => {
    if (!user?._id) {
      return;
    }
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await axios.get(`${path}/getNotification/${user._id}`, config);
      const all = res.data?.data || [];
      setMarketingNotifications(
        all.filter((n) => n.type === "marketingResultDeclared")
      );
    } catch (err) {
      console.error("Error fetching marketing notifications:", err.message);
    }
  };

  const handleMarkMarketingSeen = async (notiId) => {
    setMarketingNotifications((prev) =>
      prev.map((n) => (n._id === notiId ? { ...n, seen: true } : n))
    );
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.post(`${path}/seenNotification`, { notiId }, config);
    } catch (err) {
      console.error("Error marking notification seen:", err.message);
    }
  };


  const dispatch = useDispatch();
  const socket = useContext(WebSocketContext);
  function logoutSocketEvent() {
    socket.emit("disconnectt", user._id);
  }


  const handleRightSectionClose = () => {
    setIsRightSectionOpen(false);
  };
  const [
    contestCreateScreen,
    //  setContestCreateScreen
  ] = useState(true);
  const [editable, setEditable] = useState(false);
  const [editableProp, setEditableProp] = useState({});

  const [endedContest, setEndedContests] = useState([]);
  useEffect(() => {
    dispatch({ type: "UNSET_HEADER" });
    fetchMarketingNotifications();
  }, []);


  async function getContest() {
    const config = {
      host: `${path}`,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": `${path}`,
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const response = await axios.get(`${path}/contest`, config);
      setContestData(response.data);
    } catch (err) {
      console.log(err.message);
    }
  }

  // useEffect(() => {
  //   getContest();

  //   // setUpcommingContests(
  //   //   contestData?.filter(
  //   //     (contest) =>
  //   //       (contest?.status === "upcoming" || contest?.status === "upcomming" || contest.status === "") && (new Date(contest?.registrationStartDate)>new Date())
  //   //   )
  //   // );
  // }, []);
  useEffect(() => {
    setUpcommingContests(
      contestData?.filter(
        (contest) =>
          new Date(
            formatDate(contest.responses.sections[3]?.fields[1]?.response)
          ) >= currentDate
      )
    );
    setEndedContests(
      contestData?.filter(
        (contest) =>
          new Date(
            formatDate(contest.responses.sections[3]?.fields[1]?.response)
          ) < currentDate
      )
    );
  }, [contestData]);

  useEffect(() => {
    getContest();
  }, [editable]);

  const handleEditContest = async () => {
    try {
      history.push(`/editcontest/${selectItem}`);
    } catch (error) {
      console.log("ERROR ", error);
    }
  };
  const handleModal = (id, hasAccess) => {
    if (hasAccess === false) {
      history.push(`/editcontest/${id}`);
    } else {
      setModal(true);
    }
    setSelectItem(id);
  };
  const handleOptionsModal = (contest) => {
    setIsOptionsModal(prev => !prev);
    if (contest) {
      setSelectedCompetition(contest);
    }
  }
  const handleDataExtractionModal = () => {
    setIsDataExtractionModel(prev => !prev);
  }
  const handleAnalyticsModal = () => {
    setIsAnalyticsModel(prev => !prev);
  }
  const handleReportsModal = () => {
    setIsReportsModel(prev => !prev);
  }
  const handleUrlShortnerModal = () => {
    setIsUrlShortnerModel(prev => !prev);
  }
  const handleTestimonialUpdateModal = () => {
    setIsTestimonialUpdateModal((prev) => !prev);
  };

  return (
    <>
      <div className="relative bg-white ">
        {notificationModal &&
          (<NotificationModal setNotificationModal={setNotificationModal} notificationModal={notificationModal} />)}
        {modal && (
          <EnterPasswordModal
            onSuccess={handleEditContest}
            setModal={setModal}
            title={"Enter password to edit the competition"}
          />
        )}
        <div className={`fixed left-0 z-30`}>
          <LogoutModal
            showLogoutModal={showLogoutModal}
            setShowLogoutModal={setShowLogoutModal}
            logoutSocketEvent={logoutSocketEvent}
          />
        </div>
        <ContestOptionsModal
          open={isOptionsModal}
          toggle={handleOptionsModal}
          setNotificationModal={setNotificationModal}
          contest={selectedCompetition}
        />
        <DataExtractionModel
          open={isDataExtractionModel}
          toggle={handleDataExtractionModal}
        />
        <TestimonialUpdateModal
          open={isTestimonialUpdateModal}
          toggle={handleTestimonialUpdateModal}
          token={token}
        />
        <AnalyticsModel
          open={isAnalyticsModel}
          toggle={handleAnalyticsModal}
        />
        <ActivityReportModal open={isReportsModel} toggle={handleReportsModal} />
        <UrlShortenerModal
          open={isUrlShortnerModel}
          toggle={handleUrlShortnerModal}
        />

        <div className="main-title h-full overflow-x-auto flex items-center justify-around gap-x-4 mb-3 border-b py-2 px-4">
          <a onClick={() => setShowLogoutModal(true)}>
            <li className="flex  py-[1%] items-center cursor-pointer">
              <LogoutOutlinedIcon
                fontSize="medium"
                className="text-slate-500 mx-[2%] mr-[5%] mt-[2%]"
              />{" "}
              <span className="mt-[2%] text-[#767676] ml-[3px]">Logout </span>{" "}
            </li>
          </a>
          <button onClick={handleDataExtractionModal} className="text-[#008080] font-gilroy-medium text-nowrap" >Data Extraction</button>
          <button onClick={handleTestimonialUpdateModal} className="text-[#008080] font-gilroy-medium text-nowrap">Testimonial Update</button>
          <button onClick={handleAnalyticsModal} className="text-[#008080] font-gilroy-medium" >Analytics</button>
          <button onClick={handleReportsModal} className="text-[#008080] font-gilroy-medium" >Activity Report</button>
          <button onClick={handleUrlShortnerModal} className="text-[#008080] font-gilroy-medium" >Url Shortner</button>
          <Link to="/judgeApplicants">
            <h3 className="text-[#008080] font-gilroy-medium text-nowrap">
              Judge Applicants
            </h3>
          </Link>
          <Link to="/advertisers">
            <h3 className="text-[#008080] font-gilroy-medium">
              Advertiser
            </h3>
          </Link>
          <Link to="/antRewardsDashboard">
            <h3 className="text-[#008080] font-gilroy-medium">
              Ant Rewards Dashboard
            </h3>
          </Link>
          <Link to="/videoUploadTester">
            <h3 className="text-[#008080] font-gilroy-medium">
              Upload Tester
            </h3>
          </Link>
          {/* Marketing-admin notification bell */}
          <div className="relative">

            <button
              onClick={() => setShowMarketingBell((prev) => !prev)}
              className="relative text-[#008080] font-gilroy-medium"
              title="Result Declaration Notifications"
            >
              🔔
              {marketingUnreadCount > 0 && (
                <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center">
                  {marketingUnreadCount}
                </span>
              )}
            </button>
            {showMarketingBell && (
              <div className="fixed right-4 top-16 z-[9999] bg-white border border-gray-200 rounded-xl shadow-lg w-80 max-w-[calc(100vw-2rem)] max-h-[calc(100vh-5rem)] overflow-y-auto">
                <div className="px-4 py-2 border-b font-semibold text-gray-700 text-sm">
                  Result Declarations ({marketingNotifications.length})
                </div>
                {marketingNotifications.length === 0 ? (
                  <p className="px-4 py-3 text-sm text-gray-500">No notifications</p>
                ) : (
                  marketingNotifications.map((noti) => (
                    <div
                      key={noti._id}
                      onClick={() => !noti.seen && handleMarkMarketingSeen(noti._id)}
                      className={`px-4 py-3 border-b cursor-pointer hover:bg-gray-50 ${!noti.seen ? "bg-teal-50" : ""}`}
                    >
                      <p className="text-sm font-semibold text-gray-800">
                        {noti.otherInfo?.contestTitle || "Contest"}
                      </p>
                      <p className="text-xs text-gray-600 mt-0.5">
                        {noti.otherInfo?.message}
                      </p>
                      <p className="text-xs text-gray-400 mt-1">
                        Judge ID: {noti.fromUserId?._id || noti.fromUserId || "—"}
                      </p>
                      <p className="text-[10px] text-gray-400 mt-0.5">
                        {noti.createdAt ? new Date(noti.createdAt).toLocaleString() : ""}
                      </p>
                      {!noti.seen && (
                        <span className="text-[10px] text-teal-600 font-semibold">● Unread</span>
                      )}
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        </div>

        <div className="bg-white  hidden md:flex flex-1  justify-around items-center">
          {/* <div className="hidden font-bold text-3xl text-[#008080] ml-[3px] pt-3 h-44 w-64 border border-transparent rounded-lg xl:flex items-center justify-center capitalize self-start mt-6 shadow-lg">
            <p className="text-center">Admin Section</p>
          </div> */}
          <div className="flex justify-center   text-primary bg-white  p-4 border rounded-lg  overflow-hidden h-[35rem] gap-5">
            <div className="left-section  w-[100vw] md:w-[42vw] lg:w-[35vw] xl:w-[25vw]">
              <div className="flex flex-col sm:flex-row w-full items-center justify-center mb-2">
                {/* <button
                onClick={() => {
                  setContestCreateScreen(true);
                  setSelectedCompetition();
                }}
                className="bg-teal-500 text-white px-3 py-1 rounded-md w-full hover:bg-teal-600">
                Create Contest
              </button> */}
              </div>
              {/* <h1 className="text-center text-primary font-bold">
              Competitions
            </h1> */}
              <div className="absolute pb-12">
                {/* <h1 className="text-xl font-semibold">Upcoming</h1>
              {upcommingContests.map((contest, index) => (
                <div className="cursor-pointer">
                  <SingleCompetition
                    key={index}
                    data={contest}
                    onClick={handleCompetitionClick}
                  />
                </div>
              ))} */}
                <div className="mt-1 text-lg text-white flex border border-transparent rounded-lg mb-2 items-center justify-center font-semibold bg-[#008080] h-12 w-[20rem] ">
                  <p>Ongoing competitions ({upcommingContests.length})</p>
                </div>
                <div className="h-[30rem]  overflow-y-auto pb-12 ">
                  {upcommingContests.map((contest) => (
                    <div className="my-3" key={contest?._id}>
                      <Link
                        to={`/submissionList/${contest._id}/${contest.adminAccess}/${contest.responses.sections[2]?.fields[0]?.response}`}
                        className="no-underline">
                        <SingleCompetition
                          data={contest.responses.sections}
                          id={contest._id}
                          adminAccess={contest.adminAccess}
                        />
                      </Link>
                      <div className="flex justify-between items-center">
                        {" "}
                        <div className="flex items-center ">
                          <button
                            // to={`/editcontest/${contest._id}`}
                            onClick={() => {
                              handleModal(contest._id, contest.adminAccess);
                            }}
                            className="no-underline hover:text-red-800">
                            Edit
                          </button>
                          <Link
                            to={`/rewards/${contest._id}`}
                            className="no-underline mx-4">
                            Payout
                          </Link>
                          <DeleteContestButton contest={contest} />
                        </div>
                        <button onClick={() => handleOptionsModal(contest)}>Options</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {!contestCreateScreen && (
              <div className="w-full">
                {!editable ? (
                  <div className="overflow-y-auto hidden text-[#1c4980] w-full text-center h-full m-auto text-[1.5rem] md:flex justify-center items-start">
                    <Subcompetition
                      setEditable={setEditable}
                      setEditableProp={setEditableProp}
                      data={selectedCompetition}
                    />
                  </div>
                ) : (
                  <div className=" w-full overflow-y-auto h-full">
                    <div
                      className="bg-teal-500 cursor-pointer px-2 py-1 rounded-md text-white"
                      onClick={() => {
                        setEditableProp({});
                        setEditable(false);
                      }}>
                      Cancel
                    </div>
                    <EditContest
                      setSelectedCompetition={setSelectedCompetition}
                      setEditable={setEditable}
                      props={editableProp}
                    />
                  </div>
                )}
              </div>
            )}
            {isRightSectionOpen &&
              (!contestCreateScreen ? (
                <div className="right-section-overlap md:hidden absolute top-0 left-0  h-full bg-white z-10">
                  <div className="flex justify-end">
                    <button
                      className="text-red-500"
                      onClick={handleRightSectionClose}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-6 w-6"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                  {!editable ? (
                    <Subcompetition
                      setEditable={setEditable}
                      setEditableProp={setEditableProp}
                      data={selectedCompetition}
                    />
                  ) : (
                    <EditContest
                      setEditable={setEditable}
                      props={editableProp}
                    />
                  )}
                </div>
              ) : (
                <div className=" justify-center w-1/2 p-3">
                  {/* <h1 className="text-center font-bold text-3xl">
                  Admin Panel
                </h1> */}
                  <div className=" text-lg text-white flex border border-transparent rounded-lg mb-2 items-center justify-center font-semibold bg-[#008080] h-12 w-[20rem] ">
                    <p>Ended competitions ({endedContest.length})</p>
                  </div>
                  <div className="h-[30rem]  overflow-y-auto pb-12 ">
                    {endedContest.map((contest) => (
                      <div className="my-3" key={contest._id}>
                        <Link
                          to={`/submissionList/${contest._id}/${contest.adminAccess}`}
                          className="no-underline">
                          <SingleCompetition
                            data={contest.responses.sections}
                            id={contest._id}
                            adminAccess={contest.adminAccess}
                          />
                        </Link>
                        <div className="flex w-[20rem]">
                          {" "}
                          <button
                            // to={`/editcontest/${contest._id}`}
                            onClick={() => {
                              handleModal(contest._id, contest.adminAccess);
                            }}
                            className="no-underline hover:text-red-800">
                            Edit
                          </button>
                          <Link
                            to={`/rewards/${contest._id}`}
                            className="no-underline mx-4">
                            Payout
                          </Link>
                          <DeleteContestButton contest={contest} />
                          <button className="ml-auto" onClick={() => handleOptionsModal(contest)}>Options</button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div className="hidden">
          <MobileFooter />
        </div>
      </div>
      <div className="sm:hidden flex flex-col items-center bg-white">
        <div className="mt-4 text-lg text-white flex border border-transparent rounded-lg mb-2 items-center justify-center font-semibold bg-[#008080] h-12 w-[20rem] ">
          <p>Ongoing competitions ({upcommingContests.length})</p>
        </div>
        <div className="h-[16rem] mb-2  mx-2 overflow-y-auto pb-12 px-3">
          {upcommingContests.map((contest) => (
            <div key={contest?._id}>

              <SingleCompetition
                data={contest.responses.sections}
                id={contest._id}
                adminAccess={contest.adminAccess}
              />

              <div className="flex">
                {" "}
                <button
                  // to={`/editcontest/${contest._id}`}
                  onClick={() => {
                    handleModal(contest._id, contest.adminAccess);
                  }}
                  className="no-underline hover:text-red-800">
                  Edit
                </button>
                <Link
                  to={`/rewards/${contest._id}`}
                  className="no-underline mx-4">
                  Payout
                </Link>
                <button className="ml-auto" onClick={() => handleOptionsModal(contest)}>Options</button>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-3 text-lg text-white flex border border-transparent rounded-lg mb-2 items-center justify-center font-semibold bg-[#008080] h-12 w-[20rem] lg:w-[24rem]">
          <p>Ended competitions ({endedContest.length})</p>
        </div>
        <div className="h-[16rem]  mx-2 overflow-y-auto pb-12 px-3">
          {endedContest.map((contest) => (
            <div className="my-3" key={contest._id}>
              <SingleCompetition
                data={contest.responses.sections}
                id={contest._id}
                adminAccess={contest.adminAccess}
              />
              <div className="flex">
                {" "}
                <button
                  // to={`/editcontest/${contest._id}`}
                  onClick={() => {
                    handleModal(contest._id, contest.adminAccess);
                  }}
                  className="no-underline hover:text-red-800">
                  Edit
                </button>
                <Link
                  to={`/rewards/${contest._id}`}
                  className="no-underline mx-4">
                  Payout
                </Link>
                <button className="ml-auto" onClick={() => handleOptionsModal(contest)}>Options</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Competition;
